import React from 'react';
import { Button, Checkbox, Field, Input, Textarea } from '@fluentui/react-components';
import { MarketingTile } from './MarketingTypes';

interface Props {
  tile: MarketingTile;
  onChange: (patch: Partial<MarketingTile>) => void;
  onRemove: () => void;
}

export const TileEditor = ({ tile, onChange, onRemove }: Props): JSX.Element => {
  return (
    <div className="card marketing-editor">
      <div className="marketing-editor-header">
        <strong>Tile #{tile.id}</strong>
        <Button appearance="secondary" onClick={onRemove}>
          Remove
        </Button>
      </div>
      <div className="marketing-editor-grid">
        <Field label="Title">
          <Input
            value={tile.title ?? ''}
            onChange={(_event, data) => onChange({ title: data.value })}
            placeholder="Headline for this tile"
          />
        </Field>
        <Field label="Order">
          <Input
            type="number"
            value={String(tile.order)}
            onChange={(_event, data) => onChange({ order: Number(data.value) })}
          />
        </Field>
        <Field label="Color (hex)">
          <Input
            value={tile.color}
            onChange={(_event, data) => onChange({ color: data.value })}
            placeholder="#0f4c81"
          />
        </Field>
        <Field label="Link">
          <Input
            value={tile.link ?? ''}
            onChange={(_event, data) => onChange({ link: data.value })}
            placeholder="https://edinshall.net/..."
          />
        </Field>
      </div>
      <Field label="Content (Markdown)">
        <Textarea
          value={tile.content ?? ''}
          onChange={(_event, data) => onChange({ content: data.value })}
          rows={4}
        />
      </Field>
      <div className="marketing-editor-surfaces">
        <Checkbox
          label="Public site"
          checked={tile.surfaces.public}
          onChange={(_event, data) =>
            onChange({ surfaces: { ...tile.surfaces, public: Boolean(data.checked) } })
          }
        />
        <Checkbox
          label="Authenticated visitors"
          checked={tile.surfaces.authenticated ?? false}
          onChange={(_event, data) =>
            onChange({ surfaces: { ...tile.surfaces, authenticated: Boolean(data.checked) } })
          }
        />
        <Checkbox
          label="Portal"
          checked={tile.surfaces.portal}
          onChange={(_event, data) =>
            onChange({ surfaces: { ...tile.surfaces, portal: Boolean(data.checked) } })
          }
        />
      </div>
    </div>
  );
};
